import EventBus from "@/module/Utils/EventBus";

export default function retryableAsyncComponent(
  loader: () => Promise<any>,
  maxRetries = 5,
  delayMs = 1000,
) {
  return () => ({
    component: new Promise((resolve, reject) => {
      let attempts = 0;

      const attemptLoad = () => {
        loader()
          .then(resolve)
          .catch((err) => {
            attempts++;
            if (attempts < maxRetries) {
              setTimeout(attemptLoad, delayMs);
            } else {
              EventBus.$emit("critical-component-failed");

              reject(err);
            }
          });
      };

      attemptLoad();
    }),
    delay: 200,
    timeout: 5000,
  });
}
